import { jsx as _jsx } from "react/jsx-runtime";
import { useLogin } from '@hellodarwin/app-core/lib/providers/login-provider';
import { useMemo } from 'react';
import { useAssistantContext } from '../../providers';
import { ActorType } from '../../types/conversation.types';
import BadgeContent from './Content';
export const UserBadge = ({ authorId, authorType, }) => {
    const { user: contextUser } = useAssistantContext();
    const { user: authUser } = useLogin();
    const { authorName, displayName } = useMemo(() => {
        let displayName = '';
        let authorName = undefined;
        const isCurrentUser = authorId === (contextUser === null || contextUser === void 0 ? void 0 : contextUser.id) ||
            authorId === (authUser === null || authUser === void 0 ? void 0 : authUser.id) ||
            authorId === '';
        if (isCurrentUser) {
            authorName = (contextUser === null || contextUser === void 0 ? void 0 : contextUser.name) || (authUser === null || authUser === void 0 ? void 0 : authUser.name) || (authUser === null || authUser === void 0 ? void 0 : authUser.given_name);
            if (authorName) {
                displayName = authorType === ActorType.ADMIN ? 'Admin' : 'User';
                return { displayName, authorName };
            }
        }
        switch (authorType) {
            case ActorType.ADMIN:
                return { displayName: 'Admin', authorName: '' };
            case ActorType.CLIENT:
                return { displayName: 'User', authorName: '' };
            default:
                return { displayName: String(authorType || 'User'), authorName: '' };
        }
    }, [authorId, authorType, contextUser, authUser]);
    return _jsx(BadgeContent, { groupName: displayName, authorName: authorName });
};
